export default __webpack_public_path__ + "img/blue_health_icon.e684485751f7fed517d409fed838611f.svg";